import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const LangfuseIntegration = React.lazy(() => import("./LangfuseIntegration"));

interface LangfuseIntegrationLazyProps {
  isOpen: boolean;
  onClose: () => void;
  onRefetch?: () => void;
  brandTheme?: string | null;
}

export default function LangfuseIntegrationLazy(props: LangfuseIntegrationLazyProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <LangfuseIntegration {...props} />
    </Suspense>
  );
}
